import React from "react"

/**
 * Keeps clicks and keys on a control inside a leads row (including its portalled popup) from reaching the row.
 * Escape still bubbles, so floating popups listening on the document can close.
 */
export const stopRowEvents = {
  onClick: (event: React.MouseEvent) => event.stopPropagation(),
  onKeyDown: (event: React.KeyboardEvent) => {
    if (event.key !== "Escape") {
      event.stopPropagation()
    }
  },
}
